import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// external dependencies
import { PreviewModule } from '@core/components/preview/preview.module';
import { FilesModule } from '@core/components/files/files.module';
import { HelpersModule } from '@core/components/helpers/helpers.module';
import { HelpersEditorModule } from '@core/components/helpers/editor/editor.module';
import { VersionsModule } from '@core/components/versions/versions.module';
import { CoreStorageModule } from '@core/components/storage/storage.module';
import { SignedFilesModule } from '@core/components/signed-files/signed-files.module';


// components
// import { MessageLegacyComponent } from './message-legacy/message.component';
import { MessageAddFormComponent } from './message-add-form/message-add-form.component';
import { MessageAddComponent } from './message-add/message-add.component';
import { MessageBodyComponent } from './message-body/message-body.component';
import { MessageFilesComponent } from './message-files/message-files.component';
import { MessageComponent } from './message/message.component';
import { MessageFeedbackComponent } from './message-feedback/message-feedback.component';
import { MessageVideoComponent } from './message-video/message-video.component';
import { MessageVersionShareFeedbackComponent } from './message-version-share-feedback/message-version-share-feedback.component';

import { CorePdfViwerModule } from '@core/components/pdf/pdf.module';

import { HelperNavigationModule } from '../helpers/navigation/navigation.module';
import { FilesListModule } from '../files/lists/lists.module';
import { LayoutModalsModule } from '../layout/modals/modals.module';

@NgModule({
    imports: [
        CommonModule,
        PreviewModule,
        FilesModule, 
        CoreStorageModule,
        FilesListModule,
        HelpersModule,
        HelperNavigationModule,
        LayoutModalsModule,
        VersionsModule,
        HelpersEditorModule,
        CorePdfViwerModule,
        SignedFilesModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        //  MessageLegacyComponent,
        MessageAddFormComponent,
        MessageAddComponent,
        MessageBodyComponent,
        MessageFilesComponent,
        MessageComponent,
        MessageFeedbackComponent,
        MessageVideoComponent,
        MessageVersionShareFeedbackComponent
        //FilesUploadComponent
    ],
    exports: [
        // MessageLegacyComponent,
        MessageAddFormComponent,
        MessageAddComponent,
        MessageBodyComponent,
        MessageFilesComponent,
        MessageComponent,
        MessageFeedbackComponent,
        MessageVersionShareFeedbackComponent
        //FilesUploadComponent
    ],

})
export class MessagesModule { }
